import React from "react";
import clsx from "clsx";

import {
  ComposedChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis,
  CartesianGrid,
  Cell,
} from "recharts";

import {
  selectFormat,
  CustomizedYAxisTick,
  CustomizedYAxisTickPercentage,
  StandardTooltip,
  Error,
  getAllKeys,
  MAIN_COLORS,
} from "./../Utils/Utils.js";

const WorldCupTournamentToDate = (props) => {
  const { hasData, engagements, followers, view_time, views } = props.data;

  // const SAMPLE_DATA = {
  //   chart: [
  //     {
  //       date: "2022-01-01",
  //       facebook: 59972,
  //       instagram: 71677,
  //       twitter: 2245,
  //       view_rate: 0.2582473113302165,
  //     },
  //     {
  //       date: "2022-01-02",
  //       facebook: 20995,
  //       instagram: 81812,
  //       twitter: 950,
  //       view_rate: 0.25962876217357794,
  //     },
  //     {
  //       date: "2022-01-03",
  //       facebook: 97848,
  //       instagram: 356145,
  //       twitter: 5321,
  //       view_rate: 0.3588679401545593,
  //     },
  //     {
  //       date: "2022-01-04",
  //       facebook: 247521,
  //       instagram: 389050,
  //       twitter: 11914,
  //       view_rate: 0.3911883170429943,
  //     },
  //     {
  //       date: "2022-01-05",
  //       facebook: 344194,
  //       instagram: 798736,
  //       twitter: 17161,
  //       view_rate: 0.4228641476875702,
  //     },
  //     {
  //       date: "2022-01-06",
  //       facebook: 238412,
  //       instagram: 416257,
  //       twitter: 13342,
  //       view_rate: 0.36448759780438034,
  //     },
  //     {
  //       date: "2022-01-07",
  //       facebook: 287122,
  //       instagram: 453883,
  //       twitter: 14803,
  //       view_rate: 0.35096286231841994,
  //     },
  //     {
  //       date: "2022-01-08",
  //       facebook: 149898,
  //       instagram: 318535,
  //       twitter: 11524,
  //       view_rate: 0.31384056255729736,
  //     },
  //     {
  //       date: "2022-01-09",
  //       facebook: 74649,
  //       instagram: 127211,
  //       twitter: 3276,
  //       view_rate: 0.28746757623700775,
  //     },
  //     {
  //       date: "2022-01-10",
  //       facebook: 149264,
  //       instagram: 424845,
  //       twitter: 6224,
  //       view_rate: 0.3483219913545672,
  //     },
  //     {
  //       date: "2022-01-11",
  //       facebook: 165517,
  //       instagram: 394646,
  //       twitter: 12963,
  //       view_rate: 0.34941487399748206,
  //     },
  //     {
  //       date: "2022-01-12",
  //       facebook: 141529,
  //       instagram: 166352,
  //       twitter: 11220,
  //       view_rate: 0.3111829498412884,
  //     },
  //     {
  //       date: "2022-01-13",
  //       facebook: 235870,
  //       instagram: 147880,
  //       twitter: 11732,
  //       view_rate: 0.29269855930986605,
  //     },
  //     {
  //       date: "2022-01-14",
  //       facebook: 208130,
  //       instagram: 146827,
  //       twitter: 10529,
  //       view_rate: 0.31410339597021275,
  //     },
  //     {
  //       date: "2022-01-15",
  //       facebook: 142888,
  //       instagram: 112383,
  //       twitter: 7250,
  //       view_rate: 0.2833479223354204,
  //     },
  //     {
  //       date: "2022-01-16",
  //       facebook: 127942,
  //       instagram: 105035,
  //       twitter: 1707,
  //       view_rate: 0.27310050131962965,
  //     },
  //     {
  //       date: "2022-01-17",
  //       facebook: 138878,
  //       instagram: 62028,
  //       twitter: 3838,
  //       view_rate: 0.3355419386452394,
  //     },
  //     {
  //       date: "2022-01-18",
  //       facebook: 174347,
  //       instagram: 113435,
  //       twitter: 9701,
  //       view_rate: 0.3783096033817089,
  //     },
  //     {
  //       date: "2022-01-19",
  //       facebook: 234795,
  //       instagram: 303694,
  //       twitter: 11150,
  //       view_rate: 0.40341809454257205,
  //     },
  //     {
  //       date: "2022-01-20",
  //       facebook: 603276,
  //       instagram: 721790,
  //       twitter: 13813,
  //       view_rate: 0.3533176863754299,
  //     },
  //     {
  //       date: "2022-01-21",
  //       facebook: 533855,
  //       instagram: 272966,
  //       twitter: 8321,
  //       view_rate: 0.3040699858361643,
  //     },
  //     {
  //       date: "2022-01-22",
  //       facebook: 387966,
  //       instagram: 144497,
  //       twitter: 10923,
  //       view_rate: 0.2510481785601919,
  //     },
  //     {
  //       date: "2022-01-23",
  //       facebook: 286963,
  //       instagram: 47408,
  //       twitter: 2702,
  //       view_rate: 0.21261579374300632,
  //     },
  //     {
  //       date: "2022-01-24",
  //       facebook: 215641,
  //       instagram: 21029,
  //       twitter: 3247,
  //       view_rate: 0.260148769829652,
  //     },
  //     {
  //       date: "2022-01-25",
  //       facebook: 209134,
  //       instagram: 53661,
  //       twitter: 10026,
  //       view_rate: 0.26468742026274605,
  //     },
  //     {
  //       date: "2022-01-26",
  //       facebook: 281421,
  //       instagram: 127192,
  //       twitter: 13181,
  //       view_rate: 0.3601893711028032,
  //     },
  //     {
  //       date: "2022-01-27",
  //       facebook: 548296,
  //       instagram: 320866,
  //       twitter: 16338,
  //       view_rate: 0.3975813762197397,
  //     },
  //     {
  //       date: "2022-01-28",
  //       facebook: 685125,
  //       instagram: 115297,
  //       twitter: 12267,
  //       view_rate: 0.39694445828339103,
  //     },
  //     {
  //       date: "2022-01-29",
  //       facebook: 304795,
  //       instagram: 86396,
  //       twitter: 9369,
  //       view_rate: 0.3684150500527936,
  //     },
  //     {
  //       date: "2022-01-30",
  //       facebook: 205914,
  //       instagram: 87393,
  //       twitter: 3335,
  //     },
  //   ],
  //   phases: [
  //     {
  //       highlight: true,
  //       name: "First Quarter",
  //       start: "2022-01-01",
  //       end: "2022-03-31",
  //     },
  //     {
  //       highlight: true,
  //       name: "Second Quarter",
  //       start: "2022-04-01",
  //       end: "2022-06-30",
  //     },
  //     {
  //       highlight: true,
  //       name: "Third Quarter",
  //       start: "2022-07-01",
  //       end: "2022-09-30",
  //     },
  //   ],
  //   datepicker: false,
  // };

  // const data = SAMPLE_DATA.chart;
  // const phases = SAMPLE_DATA.phases;

  if (hasData === false) {
    return <Error minHeight={260} />;
  }

  const renderBars = (data) => {
    let bars = [];
    let all_bars = [];

    const sortedKeys = getSortedKeys(data);

    for (let i = 0; i <= data.length - 1; i++) {
      sortedKeys.forEach((source) => all_bars.push(source));
    }

    const isFixedBarWidth = data.length <= 7;

    [...new Set(all_bars)].forEach((bar, i) => {
      bars.push(
        <Bar
          key={i}
          dataKey={bar}
          stackId="stack"
          barSize={isFixedBarWidth ? 35 : null}
          fill={MAIN_COLORS[i]}
          yAxisId="left"
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${bar}-${index}`}
              fillOpacity={entry[bar] < 0 ? 0.5 : 1}
            />
          ))}
        </Bar>
      );
    });

    return bars;
  };

  const legendElement = (data) =>
    data.map((entry, i) => (
      <span key={i} className="mt-2 legend mt-md-0">
        <span
          className="legend__icon"
          style={{ background: MAIN_COLORS[i] }}
        ></span>
        <span className="legend__text" style={{ color: MAIN_COLORS[i] }}>
          {entry.replace(/_/g, " ")}
        </span>
      </span>
    ));

  const renderLegends = (data) => {
    let legends = [];
    let all_legends = [];

    const sortedKeys = getSortedKeys(data);

    sortedKeys.forEach((source) => all_legends.push(source));

    legends = [...new Set(all_legends)];
    return legendElement(legends);
  };

  const getSortedKeys = (_data) => {
    if (!_data) return [];
    if (!_data[0]) return [];
    const data = _data.filter((d) => d);

    const keys = getAllKeys(data, ["date"]);

    // Support both rates
    // const has_view_rate = data[1].hasOwnProperty("view_rate");
    // const has_engagement_rate = data[1].hasOwnProperty("engagement_rate");
    // const rate = has_view_rate
    //   ? ["view_rate"]
    //   : has_engagement_rate
    //   ? ["engagement_rate"]
    //   : "";

    const len = data.length;

    return keys
      .map((key) => ({
        key: key,
        value: data.reduce((accum, curr) => accum + (curr[key] || 0), 0) / len,
      }))
      .sort((a, b) => b.value - a.value)
      .map((d) => d.key);
    // .concat(rate);
  };

  const renderCharts = () => (
    <>
      <div className="mt-4 mb-4">
        <h5 className="widget__title widget__title--sm noselect">
          Enagement By Day
        </h5>
        {renderChart(engagements)}
      </div>

      <div className="mb-4">
        <h5 className="widget__title widget__title--sm noselect">
          Total Minutes Watched By Day
        </h5>
        {renderChart(view_time)}
      </div>

      <div className="mb-4">
        <h5 className="widget__title widget__title--sm noselect">Followers</h5>
        {renderChart(followers)}
      </div>

      <div className="mb-4">
        <h5 className="widget__title widget__title--sm noselect">Views</h5>
        {renderChart(views)}
      </div>
    </>
  );

  const renderChart = (data) => {
    // For Phase
    const getPhaseWidths = () => {
      const activePhases = data.phases.filter(
        (phase) => phase.highlight === true
      );

      if (activePhases.length && data.chart.length) {
        activePhases.unshift({
          start: data.chart[0].date,
          end: activePhases[0].start,
        });
      }

      return activePhases.map((el, i) => {
        const endIndex = data.findIndex((d) => d.date === el.end);
        const duration =
          (endIndex < 0 ? data.length - 1 : endIndex) -
          data.findIndex((d) => d.date === el.start) +
          1 +
          (i === 0 ? -1 : 0); // need for the first empty phase

        return {
          name: el.name,
          width: (duration < 0 ? 0 : (duration / data.length) * 100) + "%",
        };
      });
    };

    const phaseWidths = getPhaseWidths(data.phases);

    const renderPhaseTitles = () => (
      <div className="d-flex phase-titles">
        {phaseWidths.map((el, i) => (
          <div
            key={i}
            style={{ width: el.width }}
            className={clsx("phase-titles__item", { "no-boder": i === 0 })}
          >
            <span>{el.name}</span>
          </div>
        ))}
      </div>
    );

    const getPhaseStyles = (el, i) => ({
      width: el.width,
      backgroundColor: i % 2 === 1 ? "#FEF0EE" : "",
    });

    const formatTooltipValue = (key, data) => {
      let formatted_value = "";
      switch (key) {
        case "view_rate":
        case "engagement_rate":
          formatted_value = selectFormat("percentage", data[key]);
          break;
        default:
          formatted_value = selectFormat("number", data[key]);
      }

      return formatted_value;
    };
    return (
      <>
        {renderLegends(data.chart)}

        <div className="mt-3 composed-chart position-relative">
          {/*  Phase Background */}
          <div className="composed-chart__phase">
            {phaseWidths.map((el, i) => (
              <div
                key={i}
                className="composed-chart__phase--item"
                style={getPhaseStyles(el, i)}
              />
            ))}
          </div>

          <ResponsiveContainer height={250} width="100%">
            <ComposedChart
              data={data.chart}
              margin={{ top: 12, right: 0, bottom: 0, left: -38 }}
              stackOffset="sign"
            >
              <CartesianGrid
                stroke="#FEE5DE"
                strokeDasharray="3 3"
                vertical={false}
              />

              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(props);

                      if (payload !== null) {
                        const tooltip_data = payload[0].payload;
                        let total = "";

                        if (tooltip_data.total) {
                          total = tooltip_data.total;
                        } else {
                          total = payload.reduce(
                            (acc, cur) => acc + (cur.value || 0),
                            0
                          );
                        }

                        return (
                          <div className="standard-tooltip">
                            {tooltip_data.date && (
                              <header className="standard-tooltip__header">
                                <span className="standard-tooltip__key-header">
                                  Date:
                                </span>
                                <span className="standard-tooltip__value-header">
                                  {tooltip_data.date}
                                </span>
                              </header>
                            )}
                            <main className="standard-tooltip__main">
                              {Object.keys(tooltip_data)
                                .filter((key) => key !== "date")
                                .map((key, index) => (
                                  <div
                                    className="standard-tooltip__item"
                                    key={key}
                                  >
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{ background: MAIN_COLORS[index] }}
                                    ></span>
                                    <span
                                      className="standard-tooltip__key text-capitalize"
                                      style={{ color: MAIN_COLORS[index] }}
                                    >
                                      {key.replace(/_/g, " ")}
                                    </span>
                                    <span className="standard-tooltip__value">
                                      {formatTooltipValue(key, tooltip_data)}
                                    </span>
                                  </div>
                                ))}

                              <div className="standard-tooltip__dilimiter1"></div>

                              <div className="standard-tooltip__item">
                                <span className="standard-tooltip__key text-capitalize total">
                                  Total{" "}
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat("number", total)}
                                </span>
                              </div>
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />

              {renderBars(data.chart)}

              <XAxis
                dataKey="date"
                tickLine={false}
                axisLine={false}
                scale="auto"
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tickFormatter={(d) => selectFormat("number", d)}
                tick={<CustomizedYAxisTick />}
                yAxisId="left"
                orientation="left"
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tickFormatter={(d) => selectFormat("percentage", d)}
                tick={<CustomizedYAxisTickPercentage />}
                yAxisId="right"
                orientation="right"
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>

        {renderPhaseTitles()}
      </>
    );
  };

  return renderCharts();
};

export default WorldCupTournamentToDate;
